export const STRINGS = {
  'sign_up.email_taken_line1': 'This email already exists. ',
  'sign_up.email_taken_line2': ' instead.',
  'sign_up.email_taken_button': ' SIGN IN',
};
